module.exports = __webpack_public_path__ + "img/AscaridiaGalli.4fb389b9.png";